import { Icon, IconStatus, IconTypes, Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { ActionButton } from '../ActionButton';

import { RestrictedCustomersListItemTypes } from '.';

export const RestrictedCustomersListItemTablet: React.FC<
  RestrictedCustomersListItemTypes.Content
> = ({
  rotation,
  item,
  actionIconColor,
  actionPressable,
  actionTextColor,
  isSendDisabled,
  blockListRetryLoading,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const getStatusIcon = () => {
    if (item.statusIcon && item.statusColor && item.statusSize) {
      return (
        <IconStatus
          icon={item.statusIcon as IconTypes.Props['name']}
          color={item.statusColor as ColorTypes.Option}
          testId={`${item.statusIcon}-status-icon`}
          size={item.statusSize as IconTypes.Props['size']}
          bgColor={item.statusBackground as ColorTypes.Option}
        />
      );
    }
  };
  const [isComponentHovered, setIsComponentHovered] = useState(false);

  const currentStatus = getStatusIcon();

  return (
    <Shadow
      height={110}
      borderRadius={Spacing['inset.nano']}
      backgroundColor={Color['neutral.light']}
      paddingX={Spacing['inset.xs']}
      paddingY={Spacing['inset.xs']}
      margin={Spacing['inset.xs']}
      level={2}
      justifyContent={'space-between'}>
      <HStack paddingBottom={Spacing['inset.xs']} justifyContent={'space-between'}>
        <Text fontSize={Typography['fontsize.md']} fontWeight={Typography['fontweight.semibold']}>
          {item.requestedUserName}
        </Text>
        <Pressable
          marginRight={Spacing['inset.nano']}
          backgroundColor="transparent"
          onPress={() =>
            navigate('BlockDetails', { customerId: item.requestedUser!, channel: item.channel! })
          }
          onPressIn={() => setIsComponentHovered(true)}
          onPressOut={() => setIsComponentHovered(false)}>
          <Icon
            name="Info"
            color={Color['brand.tertiary.principal']}
            size="xxxs"
            testId="status-icon"
            backgroundColor="transparent"
          />
          <Box
            shadow={1}
            flex={1}
            position="absolute"
            top="100%"
            right={0}
            width="220px"
            bg="white"
            borderColor="gray.200"
            borderRadius="md"
            p={2}
            display={isComponentHovered ? 'flex' : 'none'}
            zIndex={1}>
            <Text backgroundColor={Color['neutral.light']}>
              Consulte os detalhes adicionais deste histórico.
            </Text>
          </Box>
        </Pressable>
      </HStack>
      <HStack zIndex={-1} justifyContent={'space-between'}>
        <HStack justifyContent={'space-between'} width="80%">
          <VStack>
            <Text paddingBottom={1} fontSize={Typography['fontsize.xs']} color={'neutral.medium'}>
              Solicitante
            </Text>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontWeight={Typography['fontweight.regular']}
              fontSize={Typography['fontsize.md']}
              flex={1}
              textAlign="start">
              {item.requestedUserType}
            </Text>
          </VStack>

          <VStack>
            <Text paddingBottom={1} fontSize={Typography['fontsize.xs']} color={'neutral.medium'}>
              Canal
            </Text>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontWeight={Typography['fontweight.regular']}
              fontSize={Typography['fontsize.md']}
              flex={1}
              textAlign="start">
              {item.channel}
            </Text>
          </VStack>

          <VStack>
            <Text paddingBottom={1} fontSize={Typography['fontsize.xs']} color={'neutral.medium'}>
              Data de bloqueio
            </Text>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontWeight={Typography['fontweight.regular']}
              fontSize={Typography['fontsize.md']}
              flex={1}
              textAlign="start">
              {item.requestedAtFormatted}
            </Text>
          </VStack>

          <VStack>
            <Text paddingBottom={1} fontSize={Typography['fontsize.xs']} color={'neutral.medium'}>
              Status
            </Text>
            <HStack flex={1} maxWidth="108%" justifyContent={'center'} alignItems={'center'}>
              {currentStatus}
              <Text
                pl={Spacing['inline.nano']}
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.regular']}
                fontSize={Utils.Responsive.All({
                  phone: Typography['fontsize.xs'],
                  tablet: Typography['fontsize.xs'],
                  desktop: Typography['fontsize.md'],
                })}
                flex={1}
                textAlign="start">
                {item.statusNameAlias}
              </Text>
            </HStack>
          </VStack>
        </HStack>

        <ActionButton
          rotation={rotation}
          blockListRetryLoading={blockListRetryLoading}
          isSendDisabled={isSendDisabled}
          canRetry={item.canRetry}
          actionPressable={actionPressable}
          actionIconColor={actionIconColor}
          actionTextColor={actionTextColor}
        />
      </HStack>
    </Shadow>
  );
};
